<template>
  <div ref="rootEl">
    <slot :name="slotName" />
  </div>
</template>

<script>
import { getTouchedScreen } from '@/lego/utils/tailwind/screen';
import { onElementResize } from '@/lego/utils/dom/element';
import { onMounted, ref, useSlots } from '@vue/composition-api';

export default {
  setup() {
    const rootEl = ref();
    const slots = useSlots();
    const slotName = ref(getSlotName());

    function getSlotName() {
      return getTouchedScreen(slots) || 'default';
    }

    onMounted(() =>
      onElementResize(rootEl.value, () => {
        slotName.value = getSlotName();
      })
    );

    return {
      rootEl,
      slotName,
    };
  },
};
</script>
